<div class="bg-white">
  <div class="container mx-auto">
    <div class="flex sm:items-center px-4 py-3">
      <div class="pr-2">
        <a class="text-gray-300" href="javascript:void(0);" (click)="back()">
          <i class="fa fa-angle-left font-bold text-3xl"></i>
        </a>
      </div>
      <div class="text-gray-300 font-medium flex-1 text-center text-sm sm:text-base">
        Knowledge Base
      </div>
    </div>
  </div>
</div>

<div class="container mx-auto px-4 py-4 min-h-90-vh lg:min-h-70-vh xl:min-h-screen mb-20">

  <!-- Button Tags Filter -->
  <app-filter-tags-button [isKnowledgeBase]="true" (searchText)="setSearchText($event)" (tagSected)="setActiveTags($event)" [tags]="tags" [(selectedTag)] = "data.activeTags"></app-filter-tags-button>

  <!-- Spinner -->
  @if (isProcessing) {
    <div class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2x text-primary" aria-hidden="true"></i>
    </div>
  }

  <!-- Knowledge Base -->
  @if (data.knowledgebaseArticles && data.knowledgebaseArticles.length > 0) {
    <div class="grid lg:grid-cols-1 gap-4 knowledge-base-items"
      >
      @for (article of data.knowledgebaseArticles | knowledgeBaseFilter:searchText:data.activeTags; track article) {
        <div class="bg-white shadow-card p-2 sm:p-3 leading-5 sm:leading-6 item cursor-pointer"
          (click)="redirectToKBArticle(article.slug)">
          <h3 class="text-gray-300 leading-6 sm:text-lg mb-1">
            <a href="javascript:void(0);"> {{article.title}} </a>
          </h3>
          <p class="text-xs md:text-sm text-gray-600 font-normal"> {{article.description}} </p>
        </div>
      }
    </div>
  }
</div>